export const RoleNames = {
  OWNER: 'Owner',
  ADMIN: 'Admin',
  MANAGER: 'Manager',
  CONSULTANT: 'Consulente',
  OPERATOR: 'Operatore',
} as const;
